import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'medal-icon',
  templateUrl: './medal-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MedalIconComponent {}
